module.exports = __webpack_public_path__ + "img/taiwan.1531219a.svg";